// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"46723deff2aa8b45","7993":"3f84bbb0d3b4b1d2","8610":"bf3b217b7955ee0e"}[chunkId] + ".css";
};